export default "__VITE_ASSET__KdLj7NrW__"